import { Dialog, Link, Stack } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import useSearchDrawerState from 'state/useSearchDrawerState';
import AppleAppStore from 'assets/apple-app-store.svg?react';
import GooglePlayStore from 'assets/google-play-store.svg?react';
import { Capacitor } from '@capacitor/core';
import { CSSProperties } from 'react';
import { AppStoreLinks, MAP_DOM_ELEMENT_ID } from '../../../constants';
import { useMapEntityDrawerState } from '../MapEntityDrawer';
import { getMapDialogCommonStyles } from '../utils';

const useStyles = makeStyles<{
  isDrawerEntitySelected: boolean;
  isSearchDrawerOpen: boolean;
}>()((theme, { isDrawerEntitySelected, isSearchDrawerOpen }) => {
  const mapDialogCommonStyles = getMapDialogCommonStyles(theme, {
    isDrawerEntitySelected,
    isSearchDrawerOpen,
    interactive: false,
    minWidth: 0,
    minSnapPct: 0,
  });

  return {
    root: {
      ...mapDialogCommonStyles.root,
      [theme.breakpoints.down('tablet')]: {
        ...(mapDialogCommonStyles.root[
          theme.breakpoints.down('tablet')
        ] as CSSProperties),
        transform: 'none',
        transition: 'none',
      },
    },
    paper: {
      ...mapDialogCommonStyles.paper,
      minWidth: 'unset',
      marginBottom: Capacitor.isNativePlatform()
        ? 'calc(30px + env(safe-area-inset-bottom))'
        : 16,
      [theme.breakpoints.down('tablet')]: {
        marginBottom: 40,
      },
    },
  };
});

export const AppStoresDialog = (): JSX.Element => {
  const { open: isSearchDrawerOpen } = useSearchDrawerState();
  const { open: isDrawerEntitySelected } = useMapEntityDrawerState();
  const { classes } = useStyles({ isDrawerEntitySelected, isSearchDrawerOpen });

  return (
    <Dialog
      open
      classes={{
        root: classes.root,
        paper: classes.paper,
      }}
      hideBackdrop
      container={(): HTMLElement | null =>
        document.getElementById(MAP_DOM_ELEMENT_ID)
      }
    >
      <Stack
        direction="row"
        spacing={2}
        sx={{ width: '100%', justifyContent: 'center', p: 2 }}
      >
        <Link
          href={AppStoreLinks.ios}
          target="_blank"
          sx={{ pointerEvents: 'auto', height: '32px' }}
        >
          <AppleAppStore width="108px" height="32px" />
        </Link>
        <Link
          href={AppStoreLinks.android}
          target="_blank"
          sx={{ pointerEvents: 'auto', height: '32px' }}
        >
          <GooglePlayStore width="108px" height="32px" />
        </Link>
      </Stack>
    </Dialog>
  );
};
